module.exports = __webpack_public_path__ + "img/502.81065444.png";